<dx-box
    #myCommunitiesBoxContainer
    *ngIf="communities"
    width="100%"
    height="100%"
    direction="col"
    class="user-communities-container"
    [elementAttr]="{ id: 'myCommunitiesBoxContainer' + (!widgetId ? '' : widgetId) }"
>
    <dxi-item baseSize="auto" *ngIf="!widgetId">
        <div *dxTemplate>
            <dx-toolbar width="100%">
                <dxi-item location="before">
                    <div *dxTemplate>
                        <dx-select-box
                            width="100%"
                            displayExpr="displayText"
                            valueExpr="key"
                            [dataSource]="accessOptions"
                            [(value)]="filterParams.includeInactive"
                            (onValueChanged)="doRefresh()"
                        ></dx-select-box>
                    </div>
                </dxi-item>
                <dxi-item location="before">
                    <div *dxTemplate class="cc-field">
                        <div class="cc-field-label">User View:</div>
                        <div class="cc-field-value">
                            <app-multi-column-selector
                                [name]="'User View'"
                                [gridSource]="userList"
                                [boxValue]="[filterParams.userId]"
                                [valueExpr]="'userId'"
                                [displayExpr]="'name'"
                                [columnDef]="userColumns"
                                [dropDownButtonTemplate]="'dropDownButton'"
                                [dropDownOptions]="{ width: 'auto' }"
                                [showClearButton]="true"
                                [placeholder]="'Select User'"
                                (gridSelectionEvent)="onUserSelection($event)"
                            ></app-multi-column-selector>
                        </div>
                    </div>
                </dxi-item>
                <dxi-item location="before">
                    <div *dxTemplate class="cc-field">
                        <div class="cc-field-label">Locations:</div>
                        <div class="cc-field-value">
                            <app-user-context-tree
                                [placeholder]="'Select Locations'"
                                [allowGlobalSelection]="false"
                                [allowManagementCompanySelection]="false"
                                [allowLocationSelection]="true"
                                [allowCommunitySelection]="false"
                                [showGlobalNode]="false"
                                [selectionMode]="'multiple'"
                                [showClearButton]="false"
                                (getContextTreeSelectedData)="onLocationsSelection($event)"
                            ></app-user-context-tree>
                        </div>
                    </div>
                </dxi-item>
                <dxi-item location="before">
                    <div *dxTemplate class="cc-field">
                        <div class="cc-field-label">Communities:</div>
                        <div class="cc-field-value">
                            <app-user-context-tree
                                #communityContextTree
                                [placeholder]="'Select Communities'"
                                [allowGlobalSelection]="false"
                                [allowManagementCompanySelection]="false"
                                [allowLocationSelection]="false"
                                [showGlobalNode]="false"
                                [selectionMode]="'multiple'"
                                [showClearButton]="false"
                                [defaultContext]="selectedContextKey"
                                [customizeLabel]="customizeContextLabel"
                                [(contextTreeBoxValue)]="contextTreeBoxValue"
                                (getContextTreeSelectedData)="onCommunitiesSelection($event)"
                            ></app-user-context-tree>
                        </div>
                    </div>
                </dxi-item>
                <dxi-item location="after">
                    <div *dxTemplate>
                        <dx-button
                            type="default"
                            icon="refresh"
                            text="Refresh"
                            hint="Refresh"
                            (onClick)="doRefresh(true)"
                        ></dx-button>
                    </div>
                </dxi-item>
            </dx-toolbar>
        </div>
    </dxi-item>

    <dxi-item baseSize="auto" *ngIf="!!widgetId">
        <div *dxTemplate>
            <dx-form width="100%" [colCount]="filterRowColCount">
                <dxi-item [colSpan]="filterRowColCount <= 4 ? 2 : 1">
                    <div *dxTemplate>
                        <dx-select-box
                            [dropDownOptions]="{ minWidth: 150 }"
                            displayExpr="displayText"
                            valueExpr="key"
                            [dataSource]="accessOptions"
                            [(value)]="filterParams.includeInactive"
                            (onValueChanged)="doRefresh()"
                        ></dx-select-box>
                    </div>
                </dxi-item>
                <dxi-item [colSpan]="2">
                    <dxo-label text="User View"></dxo-label>
                    <div *dxTemplate>
                        <app-multi-column-selector
                            cssClass="widget-drop-down-box"
                            [name]="'User View'"
                            [gridSource]="userList"
                            [boxValue]="[filterParams.userId]"
                            [valueExpr]="'userId'"
                            [displayExpr]="'name'"
                            [columnDef]="userColumns"
                            [dropDownButtonTemplate]="'dropDownButton'"
                            [dropDownOptions]="{ width: 'auto' }"
                            [showClearButton]="true"
                            [placeholder]="'Select User'"
                            (gridSelectionEvent)="onUserSelection($event)"
                        ></app-multi-column-selector>
                    </div>
                </dxi-item>
                <dxi-item [colSpan]="2">
                    <dxo-label text="Locations"></dxo-label>
                    <div *dxTemplate>
                        <app-user-context-tree
                            cssClass="widget-drop-down-box"
                            [placeholder]="'Select Locations'"
                            [allowGlobalSelection]="false"
                            [allowManagementCompanySelection]="false"
                            [allowLocationSelection]="true"
                            [allowCommunitySelection]="false"
                            [showGlobalNode]="false"
                            [selectionMode]="'multiple'"
                            [showClearButton]="false"
                            (getContextTreeSelectedData)="onLocationsSelection($event)"
                        ></app-user-context-tree>
                    </div>
                </dxi-item>
                <dxi-item [colSpan]="2">
                    <dxo-label text="Communities"></dxo-label>
                    <div *dxTemplate>
                        <app-user-context-tree
                            #communityContextTree
                            cssClass="widget-drop-down-box"
                            [placeholder]="'Select Communities'"
                            [allowGlobalSelection]="false"
                            [allowManagementCompanySelection]="false"
                            [allowLocationSelection]="false"
                            [showGlobalNode]="false"
                            [selectionMode]="'multiple'"
                            [showClearButton]="false"
                            [defaultContext]="selectedContextKey"
                            [customizeLabel]="customizeContextLabel"
                            [(contextTreeBoxValue)]="contextTreeBoxValue"
                            (getContextTreeSelectedData)="onCommunitiesSelection($event)"
                        ></app-user-context-tree>
                    </div>
                </dxi-item>
                <dxi-item>
                    <div *dxTemplate [ngClass]="filterRowColCount <= 4 ? 'cc-text-left' : 'cc-text-right'">
                        <dx-button
                            type="default"
                            icon="refresh"
                            text="Refresh"
                            hint="Refresh"
                            (onClick)="doRefresh(true)"
                        ></dx-button>
                    </div>
                </dxi-item>
            </dx-form>
        </div>
    </dxi-item>

    <dxi-item [ratio]="1">
        <div *dxTemplate class="grid-container dx-theme-border-color">
            <cc-data-grid-features
                [stateConfig]="{ storageKey: 'CC_MP_MY_COMMUNITIES', storeGroupings: true }"
                [pagingConfig]="{ defaultPageSize: 10, allowedPageSizes: [5, 10, 25, 50] }"
                [dataSource]="communities"
            >
                <dx-data-grid
                    #communityGrid
                    width="100%"
                    height="100%"
                    class="cc-vertical-center-cell-data-grid"
                    [dataSource]="communities"
                >
                    <dxi-column
                        dataField="locationName"
                        dataType="string"
                        caption="Location"
                        [groupIndex]="0"
                    ></dxi-column>
                    <dxi-column
                        dataField="communityName"
                        dataType="string"
                        caption="Community"
                        cellTemplate="communityCellTemplate"
                    ></dxi-column>
                    <dxi-column
                        dataField="managerUserDisplayText"
                        dataType="string"
                        caption="Manager"
                        cellTemplate="managerCellTemplate"
                    ></dxi-column>
                    <dxi-column
                        dataField="accountantUserDisplayText"
                        dataType="string"
                        caption="Accountant"
                        cellTemplate="accountantCellTemplate"
                    ></dxi-column>
                    <dxi-column
                        dataField="managementCompanyName"
                        dataType="string"
                        caption="Management Company"
                    ></dxi-column>
                    <dxi-column
                        dataField="status"
                        dataType="string"
                        caption="Status"
                        alignment="center"
                        cellTemplate="statusCellTempalte"
                    ></dxi-column>
                    <dxi-column dataField="communityCode" dataType="string" caption="Community ID"></dxi-column>

                    <!--Hidden Columns-->
                    <dxi-column
                        dataField="communityId"
                        dataType="number"
                        caption="Community #"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column dataField="city" dataType="string" caption="City" [visible]="false"></dxi-column>
                    <dxi-column dataField="county" dataType="string" caption="County" [visible]="false"></dxi-column>
                    <dxi-column
                        dataField="description"
                        dataType="string"
                        caption="Description"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="fiscalYearEnd"
                        dataType="string"
                        caption="Fiscal Year End"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="legalName"
                        dataType="string"
                        caption="Legal Name"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column dataField="master" dataType="string" caption="Master" [visible]="false"></dxi-column>
                    <dxi-column dataField="office" dataType="string" caption="Office" [visible]="false"></dxi-column>
                    <dxi-column
                        dataField="communityServicesUrl"
                        dataType="string"
                        caption="Services"
                        alignment="center"
                        cellTemplate="serviceCellTemplate"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="startDate"
                        dataType="date"
                        caption="Start Date"
                        [format]="dateFormat"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="terminationDate"
                        dataType="date"
                        caption="Termination Date"
                        [format]="dateFormat"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column dataField="type" dataType="string" caption="Type" [visible]="false"></dxi-column>
                    <dxi-column
                        dataField="website"
                        dataType="string"
                        caption="Website"
                        cellTemplate="websiteCellTemplate"
                        [visible]="false"
                    ></dxi-column>
                    <!--Hidden Columns-->

                    <dxo-summary>
                        <dxi-group-item
                            column="communityId"
                            summaryType="count"
                            displayFormat="Count = {0}"
                        ></dxi-group-item>
                    </dxo-summary>

                    <div *dxTemplate="let row of 'communityCellTemplate'" class="community-cell-template">
                        <ng-container *ngIf="!widgetId">
                            <img
                                loading="lazy"
                                class="community-photo dx-theme-border-color"
                                [src]="row.data.communityPhotoUrl"
                                [alt]="row.value"
                                [title]="row.value"
                                (error)="onImageLoadError($event, 'assets/images/DefaultCommunityPrimaryPhoto.jpg')"
                            />
                        </ng-container>
                        <a
                            class="cc-hyperlink community-link"
                            [ngClass]="{
                                'cc-community-intransition':
                                    row.data.status === 'InTransition' && !row.data.terminatingDate,
                                'cc-community-terminated': row.data.status === 'Terminated',
                                'cc-community-terminating':
                                    row.data.status !== 'Terminated' && !!row.data.terminatingDate
                            }"
                            (click)="onCommunityClick(row.data)"
                        >
                            {{ row.value }}
                        </a>
                    </div>
                    <div *dxTemplate="let row of 'managerCellTemplate'" class="user-cell-template">
                        <ng-container *ngIf="!widgetId">
                            <img
                                loading="lazy"
                                class="user-photo"
                                [src]="row.data.manager.profileImageUrl"
                                [alt]="row.value"
                                [title]="row.value"
                                (error)="onImageLoadError($event, 'assets/images/avatar_question_round.png')"
                            />
                        </ng-container>
                        <div class="user-details">
                            <span>
                                <app-user-bio-link
                                    [user]="row.data.manager"
                                    [communityId]="row.data.communityId"
                                ></app-user-bio-link>
                                {{ row.data.manager.title }}
                            </span>
                            <a class="cc-hyperlink" href="mailto:{{ row.data.manager.email }}">
                                {{ row.data.manager.email }}
                            </a>
                            <a class="cc-hyperlink" href="tel:{{ row.data.manager.phone }}">
                                {{ row.data.manager.phone }}
                            </a>
                        </div>
                    </div>
                    <div *dxTemplate="let row of 'accountantCellTemplate'" class="user-cell-template">
                        <ng-container *ngIf="!widgetId">
                            <img
                                loading="lazy"
                                class="user-photo"
                                [src]="row.data.accountant.profileImageUrl"
                                [alt]="row.value"
                                [title]="row.value"
                                (error)="onImageLoadError($event, 'assets/images/avatar_question_round.png')"
                            />
                        </ng-container>
                        <div class="user-details">
                            <span>
                                <app-user-bio-link
                                    [user]="row.data.accountant"
                                    [communityId]="row.data.communityId"
                                ></app-user-bio-link>
                                {{ row.data.accountant.title }}
                            </span>
                            <a class="cc-hyperlink" href="mailto:{{ row.data.accountant.email }}">
                                {{ row.data.accountant.email }}
                            </a>
                            <a class="cc-hyperlink" href="tel:{{ row.data.accountant.phone }}">
                                {{ row.data.accountant.phone }}
                            </a>
                        </div>
                    </div>
                    <div *dxTemplate="let row of 'statusCellTempalte'" class="status-cell-template">
                        <i
                            *ngIf="row.value === 'InProduction'"
                            class="cc-community-production cc-1-5x"
                            [ngClass]="iconProduction"
                            aria-hidden="true"
                            [title]="getStatus(row.data, 'In Production')"
                        ></i>
                        <i
                            *ngIf="row.value === 'InTransition'"
                            class="cc-community-intransition cc-1-5x"
                            [ngClass]="iconTransition"
                            aria-hidden="true"
                            [title]="getStatus(row.data, 'In Transition')"
                        ></i>
                        <i
                            *ngIf="row.value === 'Terminated'"
                            class="cc-community-terminated cc-1-5x"
                            [ngClass]="iconTerminate"
                            aria-hidden="true"
                            [title]="getStatus(row.data, 'Terminated')"
                        ></i>
                        <i
                            *ngIf="!!row.data.terminatingDate && row.value !== 'Terminated'"
                            class="cc-community-terminating cc-1-5x"
                            [ngClass]="iconExclamatory"
                            aria-hidden="true"
                            [title]="getStatus(row.data, 'Terminating')"
                        ></i>
                    </div>
                    <div *dxTemplate="let row of 'serviceCellTemplate'">
                        <i
                            [attr.id]="'cell-' + row.data.communityId"
                            class="cc-hyperlink dx-theme-accent-as-text-color fa-2x"
                            [ngClass]="iconView"
                            aria-hidden="true"
                            title="Click to View Services"
                            (click)="onViewServicesClick(row.data)"
                        ></i>
                        <dx-popover
                            *ngIf="row.data.showServices"
                            position="bottom"
                            [showTitle]="false"
                            [closeOnOutsideClick]="true"
                            [width]="250"
                            [target]="'#cell-' + row.data.communityId"
                            [(visible)]="row.data.showServices"
                        >
                            <div *dxTemplate="let data of 'content'">
                                <span [innerHTML]="row.data.communityServices | ccSafeHtml"></span>
                            </div>
                        </dx-popover>
                    </div>
                    <div *dxTemplate="let row of 'websiteCellTemplate'" class="cc-hyperlink">
                        <a *ngIf="!!row.value" [href]="row.data.websiteLink" target="_blank">
                            {{ row.data.websiteLink }}
                        </a>
                    </div>
                </dx-data-grid>
            </cc-data-grid-features>
        </div>
    </dxi-item>
</dx-box>

<dx-load-panel
    [position]="{ of: !widgetId ? 'body' : '#myCommunitiesBoxContainer' + widgetId }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="!widgetId"
    [shading]="!widgetId"
    [closeOnOutsideClick]="false"
></dx-load-panel>
